import type { ConfigProviderThemeVars } from "./config-provider.shared"

const darkThemeVars: ConfigProviderThemeVars = {
  gray1: "#202124",
  gray2: "#292b2e",
  gray3: "#34363a",
  gray4: "#45474c",
  gray5: "#92969c",
  gray6: "#adb0b5",
  gray7: "#d2d5d8",
  gray8: "#f7f7f7",
  orangeLight: "#3d3522",
  textColor: "#f7f7f7",
  textColor2: "#d2d5d8",
  textColor3: "#adb0b5",
  activeColor: "#34363a",
  backgroundColor: "#101010",
  backgroundColor2: "#1c1c1e",
  backgroundColorLight: "#1c1c1e",
  borderColor: "#3a3a3c",
  textLinkColor: "#7aa2d6",
  calendarMonthWatermarkColor: "rgba(100, 101, 102, 0.2)",
  pickerLoadingMaskColor: "rgba(28, 28, 30, 0.9)",
}

export default darkThemeVars
